import React, { useEffect, useRef } from "react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { PLACE_TYPE_NAME_CHOISE } from "../../constans";

import StopCard from "../StopCard";

import { useIsInViewport } from "../../hooks/useIsInViewport";

const Wrapper = styled(Box)(() => ({
  paddingTop: "38px",
}));

const WrapperTitle = styled(Typography)(() => ({
  marginBottom: "29px",
  fontFamily: "Rubik",
  fontWeight: 500,
  fontSize: "22px",
  lineHeight: 1.181,
  color: "#1a1a1a",
}));

const StopsList = styled(List)(({ theme }) => ({
  padding: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "20px",
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));

const TourStopsBlock = ({
  place,
  total,
  tourDefaultPrice,
  stops,
  setCurrentLink,
  addStation,
  setClickAdd,
  handleClose,
  uniqStops,
}) => {
  const ref = useRef(null);

  const isInViewport = useIsInViewport(ref, 0.5);

  useEffect(() => {
    if (isInViewport) {
      setCurrentLink(place);
    }
  }, [isInViewport, setCurrentLink, place]);
  
  return (
    <Wrapper ref={ref}>
      <WrapperTitle> {PLACE_TYPE_NAME_CHOISE[place]}</WrapperTitle>
      <StopsList>
        {uniqStops?.map((el) =>
        el.place_type === place ? 
           (
            <StopCard
              stop={el}
              total={total}
              tourDefaultPrice={tourDefaultPrice}
              key={el.id}
              setClickAdd={setClickAdd}
              addStation={addStation}
              handleClose={handleClose}
            />
          ) : null
        )}
      </StopsList>
    </Wrapper>
  );
};

export default TourStopsBlock;
